import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import CitationsReOrderEditing from "./citationsreorderediting";

export default class CitationsReOrder extends Plugin {
  static get pluginName() {
    return "CitationsReOrder";
  }

  static get requires() {
    return [CitationsReOrderEditing];
  }
}
